import React, { useContext, useEffect, useState } from 'react'
import Container from './container'
import SearchResults from './search-results'
import NavSynthesizers from './nav-synthesizers'
import NavAccessories from './nav-accessories'
import NavSoftwareStore from './nav-software-store'
import NavTheWave from './nav-the-wave'
import NavSupport from './nav-support'
import NavAccount from './nav-account'
import Socials from './socials'
import NewsletterSignup from './newsletter-signup'
import AppContext from './context'

const overlayFooterStyle = { 
    display: 'flex', 
    justifyContent: 'space-between', 
    marginTop: 24,
    '@media(max-width: 576px)': {
        flexDirection: 'column-reverse',
        gap: 16,
    }
}

export default function NavOverlay() {
    const { overlay, setOverlay } = useContext(AppContext)
    const [height, setHeight] = useState(null)

    useEffect(() => {
        if (typeof document === 'undefined') return
        setHeight(document.querySelector('#navbar').clientHeight)
    }, [])

    let component = <></>
    
    switch(overlay){
        case 'Search':
            component = <SearchResults />
            break;
        case 'Synthesizers':
            component = <NavSynthesizers />
            break;
        case 'Accessories':
            component = <NavAccessories />
            break;
        case 'Software Store':
            component = <NavSoftwareStore />
            break;
        case 'The Wave':
            component = <NavTheWave />
            break;
        case 'Support':
            component = <NavSupport />
            break;
        case 'Account':
            component = <NavAccount />
            break;
        default:
            break;
    }

    if(!overlay || overlay === 'Mobile') return
    return (
        <Container
            fluid
            style={{
                display: 'flex',
                flexDirection: 'column',
                position: 'absolute',
                top: '100%',
                left: 0,
                zIndex: 1020,
                height: `calc(100vh - ${height}px)`,
            }}
        >
            <Container fluid style={{ backgroundColor: 'black', }}>
                <Container
                    id='main-overlay'
                    style={{
                        maxHeight: `calc(100vh - ${height}px)`,
                        overflowY: 'auto',
                    }}
                >
                    <div css={{ padding: '32px 16px', }}>
                        {component}
                        <div css={overlayFooterStyle}>
                            <Socials />
                            <NewsletterSignup />
                        </div>
                    </div>
                </Container>
            </Container>
            <div
                css={{
                    backgroundColor: 'rgba(255, 255, 255, 0.15)',
                    backdropFilter: 'blur(10px)',
                    flexGrow: 1,
                }}
                onMouseEnter={() => setOverlay('')}
            />
        </Container>
    )
}
